import { useEffect, useState } from "react";
import { FolderPlus } from "lucide-react";
import { http, toastApiError } from "../../lib/api";
import { toast } from "../../lib/notify";
import { NewProjectForm } from "../projects/ProjectForms";

// "Proje Kartı Oluştur": Yeni Proje — Proje Kartı formu adaydaki bilgilerle ön doldurulur (Proje Adı = Ünvan); eksikler tamamlanıp kaydedilince proje + cari açılır
export default function ProspectProjectForm({ p, onDone, onCancel }) {
  const [form, setForm] = useState({
    name: p.title || "", customer: p.title || "", status: "Aktif", tax_office: p.tax_office || "", tax_number: p.tax_number || "", contact_person: "", phone: p.phone || "", email: p.email || "", kep_address: p.kep_address || "",
    contract_no: "", work_start_date: "", work_end_date: "", work_name: p.work_name || "", work_nature: "", description: [p.billing_address && `Fatura adresi: ${p.billing_address}`, p.due_days != null && `Vade: ${p.due_days} gün ${p.due_note || ""}`.trim()].filter(Boolean).join("\n"), gm_users: [],
  });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const onKey = (e) => { if (e.key !== "Escape") return; e.preventDefault(); e.stopPropagation(); onCancel(); };
    window.addEventListener("keydown", onKey, true);
    setTimeout(() => document.querySelector('[data-testid="def-projects-field-contact-person"]')?.focus(), 80);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [onCancel]);
  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await http.post(`/prospects/${p.id}/create-project`, form);
      toast.success(`"${data.project.name}" projesi ve cari kaydı açıldı`);
      onDone(data.project);
    } catch (err) { toastApiError(err); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="prospect-project-form">
      <div className="flex items-center gap-2 text-xs text-amber-900 bg-amber-50 border border-amber-300 rounded-md px-3 py-2"><FolderPlus className="w-4 h-4" /> <b>{p.title}</b> için Yeni Proje — Proje Kartı: bilgiler Satış Pazarlama'dan dolduruldu; eksik alanları tamamlayıp <b>Kartı Kaydet</b> deyin → proje ve cari kaydı açılır. ESC ile vazgeç.</div>
      <NewProjectForm form={form} setForm={setForm} onSubmit={submit} onCancel={onCancel} />
    </div>
  );
}
